'use strict'; 

let util = require('../core/util'); 
/**
 * @class ShoppingListService
 */
module.exports = class ShoppingListService {

    constructor(param) {
        const init = util.buildInitParam(param); 
        this._EventBus = init._EventBus;
        this._shoppingListsUrl = `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}me/shopping-lists`;
        
    }

    /**
     * get shopping list by user Id.
     * @param {String} userId 
     */
    getShoppingListForCustomer(userId){
        return util.makeGETRequest(this._shoppingListsUrl);
    }

}


// WEBPACK FOOTER //
// ./src/shoppingList/ShoppingListService.js